import { render, staticRenderFns } from "./ContactLists.vue?vue&type=template&id=cd8115a4&scoped=true&"
import script from "./ContactLists.vue?vue&type=script&lang=js&"
export * from "./ContactLists.vue?vue&type=script&lang=js&"
import style0 from "./ContactLists.vue?vue&type=style&index=0&id=cd8115a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd8115a4",
  null
  
)

export default component.exports